import { SEOFAQInput, SEOHowToInput } from '@jusbrasil-web/shared-utils-seo'
import Head from 'next/head'

import { getMetaTags } from './meta-tags'
import { getStructuredData } from './structured-data'

export interface BlogHeadProps {
  title: string
  blogLabel: string
  canonicalUrl: string
  description: string
  imageAlternativeText: string
  keywords: string[]
  faqItems?: SEOFAQInput[]
  howTo?: SEOHowToInput
}

export function BlogHead(blogProps: BlogHeadProps) {
  const { title, canonicalUrl } = blogProps
  const metatags = getMetaTags(blogProps)
  const structuredData = getStructuredData(blogProps)

  return (
    <Head>
      <title>{title}</title>
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonicalUrl} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      {metatags.map((props, idx) => (
        <meta {...props} key={idx} />
      ))}
    </Head>
  )
}
